import { FeatureFlagsParsed } from './featureFlags.types';

const defaultFlags: FeatureFlagsParsed = {};

function cloneFlags(flags: FeatureFlagsParsed): FeatureFlagsParsed {
    if (typeof structuredClone === 'function') {
        return structuredClone(flags);
    }

    return JSON.parse(JSON.stringify(flags)) as FeatureFlagsParsed;
}

function cloneValue<T>(value: T): T {
    if (typeof structuredClone === 'function') {
        return structuredClone(value);
    }

    return JSON.parse(JSON.stringify(value)) as T;
}

let flagsSnapshot: FeatureFlagsParsed = defaultFlags;

export const getFlagsSnapshot = (): FeatureFlagsParsed =>
    cloneFlags(flagsSnapshot);

export function getFlagSnapshot<Key extends keyof FeatureFlagsParsed>(
    key: Key,
): FeatureFlagsParsed[Key] {
    const value = flagsSnapshot[key];

    if (value && typeof value === 'object') {
        return cloneValue(value) as FeatureFlagsParsed[Key];
    }

    return value;
}

export const setFlagsSnapshot = (flags: FeatureFlagsParsed): void => {
    flagsSnapshot = cloneFlags(flags);
};
